import { GitBranch, TableIcon } from "lucide-react";
import { useState } from "react";
import BizminerAdminLayout from "@/bizminer/layouts/admin/BizminerAdminLayout";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { GicsTreeNode } from "./_components/types";
import IndustriesHierarchyView from "./_views/IndustriesHierarchyView.tsx";
import IndustriesTreeView from "./_views/IndustriesTreeView.tsx";

type View = "table" | "tree";

interface ViewToggleProps {
  value: View;
  onChange: (value: View) => void;
}

function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <Tabs value={value} onValueChange={(v) => onChange(v as View)}>
      <TabsList>
        <TabsTrigger value="table" className="gap-2">
          <TableIcon className="h-4 w-4" />
          Table
        </TabsTrigger>
        <TabsTrigger value="tree" className="gap-2">
          <GitBranch className="h-4 w-4" />
          Tree
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}

interface Props {
  sectors: GicsTreeNode[];
}

export default function Index({ sectors }: Props) {
  const [view, setView] = useState<View>("table");

  return (
    <BizminerAdminLayout title="Industries (GICS)">
      <div className="flex flex-col h-[calc(100vh-4rem)] -m-4 lg:-m-6 overflow-hidden">
        <div className="flex items-center justify-between p-4 lg:p-6 shrink-0">
          <div>
            <h1 className="text-2xl font-semibold text-foreground">
              GICS Industries
            </h1>
            <p className="text-sm text-muted-foreground">
              Global Industry Classification Standard - 11 Sectors, 25 Industry
              Groups, 74 Industries, 163 Sub-Industries
            </p>
          </div>
          <ViewToggle value={view} onChange={setView} />
        </div>

        <div className="flex-1 min-h-0 px-4 lg:px-6 pb-4 lg:pb-6">
          {view === "table" ? (
            <IndustriesHierarchyView sectors={sectors} />
          ) : (
            <IndustriesTreeView sectors={sectors} />
          )}
        </div>
      </div>
    </BizminerAdminLayout>
  );
}
